/* Da dove viene la copertura di questo record, detta in italiano.

   Quando l'indirizzo sta negli elenchi «Civici Aperti FTTH» che TIM consegna, la
   copertura si scrive senza verificare niente. Chi guarda il record fra un anno deve
   poter capire da solo perché lì c'è scritto FTTH e nessuno è andato a controllare.

   I fatti stanno sul record (`copertura_origine`, scritto dal motore): qui diventano
   frasi. Funzioni pure, provate a tavolino. */

const data = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return isNaN(d) ? '' : d.toLocaleDateString('it-IT');
};

/** True se questa copertura viene dagli elenchi di TIM e non da una verifica nostra. */
export function daElencoTim(origine) {
  return (origine || {}).fonte === 'civici_ftth';
}

export function titoloOrigine(origine) {
  return daElencoTim(origine) ? 'Copertura dagli elenchi civici di TIM' : 'Copertura verificata';
}

/** Le righe della cronistoria, nell'ordine in cui si leggono. */
export function frasiOrigine(origine) {
  const o = origine || {};
  if (!daElencoTim(o)) return [];
  const righe = [];
  righe.push(`Questo indirizzo risulta fra i civici aperti alla fibra che TIM ci ha consegnato${
    o.consegna ? `, nella consegna ${o.consegna}` : ''}.`);
  if (o.indirizzo) righe.push(`Nell'elenco è scritto «${o.indirizzo}», e il civico coincide esattamente.`);
  righe.push('Non è stata fatta nessuna verifica sul sito TIM: la risposta era già nostra.');
  if (o.vendibilita === 'Altro Operatore') {
    righe.push('La fibra su quel civico non è di FiberCop ma di un altro operatore '
      + '(la cosiddetta «fibra bianca», rete del piano pubblico che TIM rivende): '
      + 'si vende, ma cambiano prodotto e tempi di attivazione.');
  } else if (o.vendibilita) {
    righe.push(`Infrastruttura ${o.vendibilita}.`);
  }
  if (o.dieci_gb) righe.push('Su questo civico la fibra arriva a 10 Giga.');
  if (o.at) righe.push(`Informazione presa dall'archivio il ${data(o.at)}.`);
  return righe;
}
